/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { CompetitionField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedCompetitionModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related competition"
    subtitle="Find competition related to this article"
    okText="ADD COMPETITION"
    onSubmit={({ competition }) => onSubmit(competition)}
  >
    <CompetitionField
      label="Choose a competition:"
      name="competition"
      extra={null}
      wrapperCol={{ span: 24 }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Competition is required' }]}
    />
  </RelatedContentModal>
);

const Item = (competition) => <InfoItem>{competition.name}</InfoItem>;

RelatedCompetitionModal.Item = Item;

export default RelatedCompetitionModal;
